// --- inside SideBarRedesign.js ---
import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import {
  Stack,
  Menu,
  MenuItem,
  Avatar,
  Button,
  Box,
  Drawer,
  CssBaseline,
  AppBar,
  Toolbar,
  Typography,
  Divider,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import configServ from "../../services/config";
import { assignType } from "../../redux/reducers/Admin";
import {
  rSetCompanyCode,
  rSetCompanyId,
  rSetCompanyName,
} from "../../redux/reducers/GlobalVariables";

import SiteLogo from "../Assets/images/siteLogoWhite.svg";
import SiteLogoInitial from "../Assets/images/SiteIcon.svg";
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemButton,
  Collapse,
} from "@mui/material";
import {
  Dashboard as DashboardIcon,
  Folder as FolderIcon,
  Group as GroupIcon,
  Label as LabelIcon,
  Category as CategoryIcon,
  ExpandLess,
  ExpandMore,
  ExpandMoreOutlined,
  Book,
  LocationCityOutlined,
  AppRegistration,
  VerifiedOutlined,
  NoEncryptionGmailerrorredOutlined,
  MasksTwoTone,
  CenterFocusStrong,
  PeopleAltOutlined,
  ReportGmailerrorredOutlined,
  BatchPrediction,
  AppRegistrationTwoTone,
  AttachmentOutlined,
  EdgesensorLowOutlined,
  Report,
  MeetingRoomOutlined,
  Instagram,
  HolidayVillage,
} from "@mui/icons-material";

import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import LogoutIcon from "@mui/icons-material/Logout";
import AccountBoxIcon from "@mui/icons-material/AccountBox";

import Logout from "../Logout/Logout";
import YesNoDialog from "../AlertDialog/YesNoDialog";
import CheckAndReturn from "../../utility/CheckAndReturn";

const drawerWidth = 240;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const CustomAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  backgroundColor: "#555",
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

// ---------------- FUNCTIONAL COMPONENT -----------------
const SideBarRedesign = () => {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open1 = Boolean(anchorEl);
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const open2 = Boolean(anchorEl2);

  const menuRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openMenu, setOpenMenu] = useState(null);

  const { user_id, company_id, companyName, is_super, permissions } =
    useSelector((state) => state.GlobalVariables);

  const [companyLogo, setCompanyLogo] = useState("");
  const [companyList, setCompanyList] = useState([]);
  const [companyData, setCompanyData] = useState({});
  const [companySwitchPopup, setCompanySwitchPopup] = useState(false);
  const [isLogutDialogOpen, setIsLogutDialogOpen] = useState(false);

  const assignCompanyLogo = async () => {
    try {
      const result = await configServ.company_logo({ company_id: company_id });
      if (result.image) {
        setCompanyLogo(result.image);
      } else {
        setCompanyLogo("");
      }
    } catch (err) {
      console.log(err);
    }
  };

  // ----------- functions copied from Header ----------------
  function stringToColor(string) {
    if (!string) return "#000000";
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = "#";
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    return color;
  }

  function stringAvatar(name) {
    const initials = name
      ? name.includes(" ")
        ? `${name.split(" ")[0][0].toUpperCase()}${name
            .split(" ")[1][0]
            .toUpperCase()}`
        : `${name[0].toUpperCase()}`
      : "W";

    return {
      sx: { bgcolor: stringToColor(name) },
      children: initials,
    };
  }

  const fetchCompanyList = async () => {
    try {
      const result = await configServ.getActiveCompanyList({
        user_id: user_id,
      });
      setCompanyList(result);
    } catch (err) {
      console.log(err);
    }
  };

  const switchCompany = async () => {
    try {
      if (companyData) {
        dispatch(rSetCompanyId(companyData.id));
        const res = await configServ.getCompanyById({ id: companyData.id });
        if (res.status === 200) {
          dispatch(rSetCompanyName(res.data.CompanyName));
          dispatch(rSetCompanyCode(res.data.CompanyCode));
        }
        dispatch(assignType(companyData.CompanyType));
      } else {
        dispatch(rSetCompanyId(null));
        dispatch(rSetCompanyName("Select Center"));
        dispatch(rSetCompanyCode(""));
        dispatch(assignType("Service"));
      }
    } catch (err) {
      console.log(err);
    }
    navigate(0);
  };

  const handleCompanySwitchPopup = () => {
    setCompanySwitchPopup(!companySwitchPopup);
  };

  const handleLogout = () => {
    setIsLogutDialogOpen(!isLogutDialogOpen);
  };

  // -------- useEffect ------------
  useEffect(() => {
    fetchCompanyList();
    assignCompanyLogo();
  }, []);

  // -------- handlers ------------
  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleClick2 = (event) => setAnchorEl2(event.currentTarget);
  const handleClose2 = () => setAnchorEl2(null);

  // --------- RENDER -------------
  return (
    <>
      <Logout open={isLogutDialogOpen} setOpen={setIsLogutDialogOpen} />
      <YesNoDialog
        open={companySwitchPopup}
        setOpen={setCompanySwitchPopup}
        title={"Company Switch"}
        message={"Do you want to switch company?"}
        handleYes={switchCompany}
      />

      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <CustomAppBar
          position="fixed"
          open={open}
          sx={{ backgroundColor: "white", color: "black" }}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{ mr: 2, ...(open && { display: "none" }) }}
            >
              <MenuIcon sx={{ color: "black" }} />
            </IconButton>

            {/* company logo / name */}
            <Stack maxWidth={1000} height="100%" justifyContent="center">
              <IconButton
                id="basic-button"
                aria-controls={open1 ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={is_super === 1 ? handleClick : () => {}}
              >
                {companyLogo === "" ? (
                  <Typography
                    variant="button"
                    sx={{
                      p: 1,
                      fontSize: { xs: "12px", md: "16px" },
                      fontWeight: 700,
                      color: "black",
                      ":hover": { color: "grey" },
                    }}
                  >
                    {companyName}
                  </Typography>
                ) : (
                  <Box
                    component="img"
                    src={companyLogo || SiteLogoInitial}
                    alt="logoInitial"
                    height="50"
                    title={companyName}
                    sx={{
                      borderRadius: "50%",
                      width: "50px",
                      objectFit: "cover",
                    }}
                  />
                )}
              </IconButton>

              {/* company list dropdown */}
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open1}
                onClose={handleClose}
              >
                {companyList
                  .sort((a, b) => a.CompanyName.localeCompare(b.CompanyName))
                  .map((item) => (
                    <MenuItem
                      key={item.id}
                      onClick={() => {
                        handleClose();
                        setCompanyData(item);
                        handleCompanySwitchPopup();
                      }}
                    >
                      {item.CompanyLogo ? (
                        <>
                          <img
                            style={{ padding: "5px", maxHeight: 40 }}
                            src={item.CompanyLogo}
                            alt={item.CompanyName}
                          />
                          <span style={{ color: "#1e61b4", marginLeft: 8 }}>
                            {item.CompanyName}
                          </span>
                        </>
                      ) : (
                        <Typography sx={{ color: "#1e61b4" }}>
                          {item.CompanyName}
                        </Typography>
                      )}
                    </MenuItem>
                  ))}
              </Menu>
            </Stack>

            <Box sx={{ flexGrow: 1 }} />

            {/* profile */}
            <Stack direction="row" spacing={4} alignItems="center">
              <IconButton
                id="basic-button2"
                aria-controls={open2 ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open2 ? "true" : undefined}
                onClick={handleClick2}
                sx={{ borderRadius: "20px" }}
              >
                <Avatar {...stringAvatar(companyName)} />
                {anchorEl2 === null ? (
                  <ArrowDropDownIcon
                    sx={{ marginRight: 1, fontSize: "30px" }}
                  />
                ) : (
                  <ArrowDropUpIcon
                    sx={{ marginRight: 1, fontSize: "30px" }}
                    color="primary"
                  />
                )}
              </IconButton>
            </Stack>

            {/* profile menu */}
            <Menu
              id="basic-menu2"
              anchorEl={anchorEl2}
              open={open2}
              onClose={handleClose2}
            >
              <Link style={{ textDecoration: "none" }} to="/profile">
                <MenuItem onClick={handleClose2} sx={{ padding: 0 }}>
                  <Button
                    sx={{ color: "black", padding: 2 }}
                    startIcon={<AccountBoxIcon />}
                  >
                    My Profile
                  </Button>
                </MenuItem>
              </Link>
              <MenuItem
                onClick={() => {
                  handleClose2();
                  handleLogout();
                }}
                sx={{ padding: 0 }}
              >
                <Button
                  sx={{ color: "black", padding: 2 }}
                  startIcon={<LogoutIcon />}
                >
                  Log Out
                </Button>
              </MenuItem>
            </Menu>
          </Toolbar>
        </CustomAppBar>

        {/* Drawer */}
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
              backgroundColor: "#555",
              color: "white",
            },
          }}
          variant="persistent"
          anchor="left"
          open={open}
          ref={menuRef}
        >
          <DrawerHeader>
            <img src={SiteLogo} alt="logo" width="150" hidden={!open} />
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "ltr" ? (
                <ChevronLeftIcon sx={{ color: "white" }} />
              ) : (
                <ChevronRightIcon sx={{ color: "white" }} />
              )}
            </IconButton>
          </DrawerHeader>
          <Divider />
          <Divider />

          <List>
            {/* Dashboard (no submenu) */}
            <ListItem button component={Link} to="/dashboard">
              <ListItemIcon>
                <DashboardIcon sx={{ color: "white" }} />
              </ListItemIcon>
              <ListItemText primary="Dashboard" />
            </ListItem>

            {/* Master Entry (submenu) */}
            {CheckAndReturn.PermissionHandler(
              "access-master-entry",
              permissions
            ) === true && (
              <ListItemButton
                onClick={() =>
                  setOpenMenu(openMenu === "master" ? null : "master")
                }
              >
                <ListItemIcon>
                  <FolderIcon sx={{ color: "white" }} />
                </ListItemIcon>
                <ListItemText primary="Master Entry" />
                {openMenu === "master" ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
            )}

            <Collapse in={openMenu === "master"} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={Link}
                  to="/master-entry/brand"
                  onClick={() => handleDrawerClose()}
                >
                  <ListItemIcon>
                    <LabelIcon sx={{ color: "white" }} />{" "}
                    {/* 👈 submenu icon */}
                  </ListItemIcon>
                  <ListItemText primary="Brand" />
                </ListItemButton>

                <ListItemButton
                  sx={{ pl: 4 }}
                  component={Link}
                  to="/meeting-link"
                  onClick={() => handleDrawerClose()}
                >
                  <ListItemIcon>
                    <MeetingRoomOutlined sx={{ color: "white" }} />{" "}
                    {/* 👈 submenu icon */}
                  </ListItemIcon>
                  <ListItemText primary="Meeting Link" />
                </ListItemButton>

                <ListItemButton
                  sx={{ pl: 4 }}
                  component={Link}
                  to="/master-entry/teacher-batch-assignment"
                  onClick={() => handleDrawerClose()}
                >
                  <ListItemIcon>
                    <Instagram sx={{ color: "white" }} />{" "}
                    {/* 👈 submenu icon */}
                  </ListItemIcon>
                  <ListItemText primary="Instructor" />
                </ListItemButton>

                <ListItemButton
                  sx={{ pl: 4 }}
                  component={Link}
                  to="/master-entry/category"
                  onClick={() => handleDrawerClose()}
                >
                  <ListItemIcon>
                    <CategoryIcon sx={{ color: "white" }} />{" "}
                    {/* 👈 submenu icon */}
                  </ListItemIcon>
                  <ListItemText primary="Category" />
                </ListItemButton>

                <ListItemButton
                  sx={{ pl: 4 }}
                  component={Link}
                  to="/master-entry/group"
                  onClick={() => handleDrawerClose()}
                >
                  <ListItemIcon>
                    <GroupIcon sx={{ color: "white" }} />{" "}
                    {/* 👈 submenu icon */}
                  </ListItemIcon>
                  <ListItemText primary="Group" />
                </ListItemButton>

                <ListItemButton
                  sx={{ pl: 4 }}
                  component={Link}
                  to="/master-entry/item"
                  onClick={() => handleDrawerClose()}
                >
                  <ListItemIcon>
                    <Book sx={{ color: "white" }} /> {/* 👈 submenu icon */}
                  </ListItemIcon>
                  <ListItemText primary="Exam" />
                </ListItemButton>

                <ListItemButton
                  sx={{ pl: 4 }}
                  component={Link}
                  to="/master-entry/location"
                  onClick={() => handleDrawerClose()}
                >
                  <ListItemIcon>
                    <LocationCityOutlined sx={{ color: "white" }} />{" "}
                    {/* 👈 submenu icon */}
                  </ListItemIcon>
                  <ListItemText primary="Location" />
                </ListItemButton>

                <ListItemButton
                  sx={{ pl: 4 }}
                  component={Link}
                  to="/master-entry/batch"
                  onClick={() => handleDrawerClose()}
                >
                  <ListItemIcon>
                    <BatchPrediction sx={{ color: "white" }} />{" "}
                    {/* 👈 submenu icon */}
                  </ListItemIcon>
                  <ListItemText primary="Batch" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={Link}
                  to="/master-entry/holiday"
                  onClick={() => handleDrawerClose()}
                >
                  <ListItemIcon>
                    <HolidayVillage sx={{ color: "white" }} />{" "}
                    {/* 👈 submenu icon */}
                  </ListItemIcon>
                  <ListItemText primary="Holiday" />
                </ListItemButton>
              </List>
            </Collapse>

            {CheckAndReturn.PermissionHandler("access-student", permissions) ===
              true && (
              <ListItem
                button
                component={Link}
                to="/candidate"
                onClick={() => handleDrawerClose()}
              >
                <ListItemIcon>
                  <AppRegistration sx={{ color: "white" }} />
                </ListItemIcon>
                <ListItemText primary="Exam Attend" />
              </ListItem>
            )}

            {CheckAndReturn.PermissionHandler(
              "access-registration",
              permissions
            ) === true && (
              <ListItem
                button
                component={Link}
                to="/student-registration"
                onClick={() => handleDrawerClose()}
              >
                <ListItemIcon>
                  <AppRegistrationTwoTone sx={{ color: "white" }} />
                </ListItemIcon>
                <ListItemText primary="Registration" />
              </ListItem>
            )}

            {CheckAndReturn.PermissionHandler("access-student", permissions) ===
              true && (
              <ListItem
                button
                component={Link}
                to="/verified-candidate"
                onClick={() => handleDrawerClose()}
              >
                <ListItemIcon>
                  <VerifiedOutlined sx={{ color: "white" }} />
                </ListItemIcon>
                <ListItemText primary="Verified Candidate" />
              </ListItem>
            )}

            {CheckAndReturn.PermissionHandler(
              "access-enrollment",
              permissions
            ) === true && (
              <ListItem
                button
                component={Link}
                to="/enroll"
                onClick={() => handleDrawerClose()}
              >
                <ListItemIcon>
                  <NoEncryptionGmailerrorredOutlined sx={{ color: "white" }} />
                </ListItemIcon>
                <ListItemText primary="Enrollment" />
              </ListItem>
            )}

            {CheckAndReturn.PermissionHandler("access-center", permissions) ===
              true && (
              <ListItem
                button
                component={Link}
                to="/center"
                onClick={() => handleDrawerClose()}
              >
                <ListItemIcon>
                  <CenterFocusStrong sx={{ color: "white" }} />
                </ListItemIcon>
                <ListItemText primary="Center" />
              </ListItem>
            )}

            {CheckAndReturn.PermissionHandler(
              "access-access-master",
              permissions
            ) === true && (
              <ListItem
                button
                component={Link}
                to="/access-master"
                onClick={() => handleDrawerClose()}
              >
                <ListItemIcon>
                  <MasksTwoTone sx={{ color: "white" }} />
                </ListItemIcon>
                <ListItemText primary="Access Master" />
              </ListItem>
            )}

            <ListItem
              button
              component={Link}
              to="/profile"
              onClick={() => handleDrawerClose()}
            >
              <ListItemIcon>
                <PeopleAltOutlined sx={{ color: "white" }} />
              </ListItemIcon>
              <ListItemText primary="Profile" />
            </ListItem>

            {CheckAndReturn.PermissionHandler(
              "access-exam-report",
              permissions
            ) === true && (
              <ListItem
                button
                component={Link}
                to="/exam-report"
                onClick={() => handleDrawerClose()}
              >
                <ListItemIcon>
                  <ReportGmailerrorredOutlined sx={{ color: "white" }} />
                </ListItemIcon>
                <ListItemText primary="Exam Report" />
              </ListItem>
            )}

            {CheckAndReturn.PermissionHandler(
              "access-batch-attendance",
              permissions
            ) === true && (
              <ListItem
                button
                component={Link}
                to="/batch-attendance"
                onClick={() => handleDrawerClose()}
              >
                <ListItemIcon>
                  <AttachmentOutlined sx={{ color: "white" }} />
                </ListItemIcon>
                <ListItemText primary="Batch Attendance" />
              </ListItem>
            )}

            {CheckAndReturn.PermissionHandler(
              "access-batch-enrollment",
              permissions
            ) === true && (
              <ListItem
                button
                component={Link}
                to="/batch-enrollment"
                onClick={() => handleDrawerClose()}
              >
                <ListItemIcon>
                  <EdgesensorLowOutlined sx={{ color: "white" }} />
                </ListItemIcon>
                <ListItemText primary="Batch Enrollment" />
              </ListItem>
            )}

            {CheckAndReturn.PermissionHandler(
              "access-attendance-report",
              permissions
            ) === true && (
              <ListItem
                button
                component={Link}
                to="/attendance-report"
                onClick={() => handleDrawerClose()}
              >
                <ListItemIcon>
                  <Report sx={{ color: "white" }} />
                </ListItemIcon>
                <ListItemText primary="Attendance Report" />
              </ListItem>
            )}
          </List>
        </Drawer>
      </Box>
    </>
  );
};

export default SideBarRedesign;
